import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientMedicationSelector } from '../selectors/patientMedication.selector'
import { getPatientMedicationsListSelector } from '../selectors/patientMedicationsList.selector'
import { setPatientMedicationsList } from '../store/patientMedications.actions'
import { PatientMedicationsConstants } from '../store/patientMedications.constants'
import { IPatientMedication, IPatientMedications } from '../store/patientMedications.types'

export function* deleteMedication() {
  const medications: IPatientMedications = yield select(getPatientMedicationsListSelector)
  const medication: IPatientMedication = yield select(getPatientMedicationSelector)
  if (medication && medications) {
    yield put(setPatientMedicationsList(medications.filter((medicationInfo) => medication.key !== medicationInfo?.key)))
  }
}
export function* deleteMedicationSaga() {
  yield takeLatest([PatientMedicationsConstants.DELETE_MEDICATION], deleteMedication)
}
